import PagesListContainer from './PagesListContainer'
import PagesList from './PagesList'
export { PagesList }
export { PagesListContainer }
export default PagesListContainer



// WEBPACK FOOTER //
// ./src/pages/PagesList/index.js